const Locked = () => (
    <svg
        width='9'
        height='13'
        viewBox='0 0 9 13'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
    >
        <path
            d='M7.3125 4.7V4.1V3.5C7.3125 2.70435 7.01618 1.94129 6.48874 1.37868C5.96129 0.81607 5.24592 0.5 4.5 0.5C3.75408 0.5 3.03871 0.81607 2.51126 1.37868C1.98382 1.94129 1.6875 2.70435 1.6875 3.5V4.7C1.23995 4.7 0.810725 4.88964 0.494257 5.22721C0.17779 5.56477 0 6.02261 0 6.5V10.7C0 11.1774 0.17779 11.6352 0.494257 11.9728C0.810725 12.3104 1.23995 12.5 1.6875 12.5H7.3125C7.76005 12.5 8.18928 12.3104 8.50574 11.9728C8.82221 11.6352 9 11.1774 9 10.7V6.5C9 6.02261 8.82221 5.56477 8.50574 5.22721C8.18928 4.88964 7.76005 4.7 7.3125 4.7ZM2.8125 3.5C2.8125 3.02261 2.99029 2.56477 3.30676 2.22721C3.62322 1.88964 4.05245 1.7 4.5 1.7C4.94755 1.7 5.37678 1.88964 5.69324 2.22721C6.00971 2.56477 6.1875 3.02261 6.1875 3.5V4.1V4.7H2.8125V3.5ZM7.875 10.7C7.875 10.8591 7.81574 11.0117 7.71025 11.1243C7.60476 11.2368 7.46168 11.3 7.3125 11.3H1.6875C1.53832 11.3 1.39524 11.2368 1.28975 11.1243C1.18426 11.0117 1.125 10.8591 1.125 10.7V6.5C1.125 6.34087 1.18426 6.18826 1.28975 6.07574C1.39524 5.96321 1.53832 5.9 1.6875 5.9H7.3125C7.46168 5.9 7.60476 5.96321 7.71025 6.07574C7.81574 6.18826 7.875 6.34087 7.875 6.5V10.7Z'
            fill='#FF7675'
        />
    </svg>
);

export default Locked;
